import * as _ from 'lodash';
export default class SettingMailController {
	/* @ngInject */
	constructor(
		SettingPortailService,
		SitesService,
		SocietesService,
		PersonnesService,
		MassiaApplicationService,
		DomainesService,
		DonneeFiltreeUtilisateursService
	) {
		this.SettingPortailService = SettingPortailService;
		this.SitesService = SitesService;
		this.SocietesService = SocietesService;
		this.PersonnesService = PersonnesService;
		this.MassiaApplicationService = MassiaApplicationService;
		this.DomainesService = DomainesService;
		this.DonneeFiltreeUtilisateursService = DonneeFiltreeUtilisateursService;
	}

	async $onInit() {
		//All Setting Mail
		this.formListContactMail = [];

		//Formulaire
		this.form;

		// Loader
		this.loading = false;

		// All data
		this.salaries = [];
		this.settingMails = [];

		await this.initLists();

		this.showForm = false;
		this.selectedSalaries = [];

		this.prepareContactMails();
	}

	async initLists() {
		//filtered list
		this.domaines = [];
		this.sites = [];
		this.societes = [];
		this.sitesFiltered = [];
		this.salariesFiltered = [];
		this.selectedSalaries = [];
		await this.getSitesCommerciaux();
		await this.getPersonnes();
		await this.getSocietes();
		await this.getDomaines();
		await this.getAllSettingMail();
		this.sitesFiltered = this.sites;
		this.salariesFiltered = this.salaries;
	}

	async getSitesCommerciaux() {
		this.sites = (await this.SitesService.getSitesCommerciaux()).items;
		this.sitesFiltered = this.sites;
	}

	async getPersonnes() {
		// TODO : voir comment recup les filtres utilisateur Societes et Sites
		this.salaries = (await this.PersonnesService.getPersonnes(true, 2, null, null, null, this.MassiaApplicationService.getApplication())).items;

		await Promise.all(
			this.salaries.map(async (salarie) => {
				var res = await this.DonneeFiltreeUtilisateursService.getDonneeFiltreeUtilisateur(salarie.id, 'gestion');
				salarie.idFiltreSocietes = res.idFiltreSocietes;
				salarie.idFiltreSites = res.idFiltreSites;
			})
		);

		this.salaries = this.salaries.filter((salarie) => !!salarie.mail);
	}

	async getSocietes() {
		this.societes = (await this.SocietesService.getSocietes(null, null, null, 1, this.MassiaApplicationService.getApplication())).items;
	}

	async getDomaines() {
		this.domaines = await this.DomainesService.getDomainPortails();
		this.domaines = this.domaines
			.filter((domaine) => domaine.code === 'PORTAL_USERS' || domaine.code === 'DAP')
			.map(({ libelle, ...rest }) => ({
				...rest,
				nom: libelle
			}));
	}

	async getAllSettingMail() {
		var res = await this.SettingPortailService.getAllSettingMail();
		this.formListContactMail = [];
		this.formListContactMail = res.data;
	}

	async filterSitesBySociete(id) {
		if (id) {
			this.sitesFiltered = this.sites.filter((site) => site.societeId === id);
		}
	}

	filterSalaries(from) {
		if (!this.form.site[0] && !this.form.societe[0]) {
			this.resetSalaries();
			return;
		}

		if (from === 'societe') {
			if (this.form.societe[0]?.id) {
				this.filterBySociete(this.form.societe[0].id);
			} else {
				this.filterSalaries('site');
			}
		}

		if (from === 'site') {
			if (this.form.site[0]?.id) {
				this.filterBySite(this.form.site[0].id);
			} else {
				this.filterSalaries('societe');
			}
		}
	}

	async resetSalaries() {
		await this.getPersonnes();
		await this.getSitesCommerciaux();
		await this.getSocietes();
		this.salariesFiltered = this.salaries;
	}

	filterBySociete(societeId) {
		// Filtrer les salariés dont l'un des éléments dans idFiltreSocietes a un idSociete égal à societeId
		this.salariesFiltered = this.salaries.filter(
			(salarie) => Array.isArray(salarie.idFiltreSocietes) && salarie.idFiltreSocietes.some((filtre) => filtre.idSociete === societeId)
		);
		this.filterSitesBySociete(societeId);
	}

	filterBySite(siteId) {
		// TODO :Recuperer chaque salarié qui l'idSite contenue dans la liste filtre user site
		this.salariesFiltered = this.salaries.filter((salarie) => salarie.idFiltreSites.includes(siteId));
		this.salariesFiltered = this.salaries.filter(
			(salarie) => Array.isArray(salarie.idFiltreSites) && salarie.idFiltreSites.some((filtre) => filtre.idSite === siteId)
		);
	}

	async openForm(doReinit = false) {
		this.loading = true;
		if (doReinit) await this.initLists();
		this.showForm = true;
		this.form = {
			id: null,
			societe: null,
			site: null,
			salaries: null,
			domains: null
		};
		this.loading = false;
	}

	closeForm() {
		this.showForm = false;
	}

	async getSalaries(salaries) {
		if (salaries.length > 0) {
			this.TooltipSalaries = '<ul class="text-left">';
			this.TooltipSalaries += _.map(salaries, function (n) {
				return '<li>' + n.nom + ' ' + n.prenom + '</li>';
			}).join('');
			this.TooltipSalaries += '</ul>';
		} else {
			this.TooltipSalaries = null;
		}
	}

	async editContactMail(index) {
		this.loading = true;

		const contactMailToEdit = this.formListContactMail[index];

		// Charger les listes avant d'appliquer les filtres
		await this.initLists();

		this.form = {
			id: contactMailToEdit.id,
			societe: contactMailToEdit.societe,
			site: contactMailToEdit.site,
			salaries: contactMailToEdit.salaries,
			domains: contactMailToEdit.domaines
		};

		// Appliquer le filtre
		if (this.form.societe && this.form.societe[0]?.id) {
			this.filterBySociete(this.form.societe[0].id);
		} else if (this.form.site && this.form.site[0]?.id) {
			this.filterBySite(this.form.site[0].id);
		}

		this.showForm = true;
		console.log(this.formListContactMail);

		this.societes.forEach((s) => {
			if (contactMailToEdit.societe.map((soc) => soc.id).includes(s.id)) {
				s.selected = true;
			}
		});

		this.sitesFiltered.forEach((s) => {
			if (contactMailToEdit.site.map((site) => site.id).includes(s.id)) {
				s.selected = true;
			}
		});

		this.domaines.forEach((s) => {
			if (contactMailToEdit.domains.map((d) => d.code).includes(s.code)) {
				s.selected = true;
			}
		});

		this.salariesFiltered.forEach((s) => {
			if (contactMailToEdit.salaries.map((d) => d.id).includes(s.id)) {
				s.selected = true;
				this.selectedSalaries.push(s);
			}
		});

		this.loading = false;
	}

	selectItem(data) {
		const index = this.selectedSalaries.findIndex((item) => item.id === data.id);
		if (index !== -1) {
			this.selectedSalaries.splice(index, 1);
		} else {
			this.selectedSalaries.push(data);
		}
	}

	async deleteContactMail($index, id) {
		if (this.form && this.form.id === id) {
			this.close();
		}
		await this.SettingPortailService.deleteMailContact(id);
		await this.getAllSettingMail();
	}

	async save() {
		this.loading = true;
		if (this.form.id && this.form.id != 0) {
			await this.SettingPortailService.UpdateMailContact(this.form);
		} else {
			await this.SettingPortailService.SaveMailContact(this.form);
		}
		this.formListContactMail = [];
		this.form = null;
		await this.getAllSettingMail();

		this.showForm = false;
		this.loading = false;
	}

	close() {
		this.loading = true;
		this.showForm = false;
		this.form = {
			id: null,
			societe: null,
			site: null,
			salaries: null,
			domains: null
		};
		this.loading = false;
	}

	getDomainNames(domains) {
		if (!domains || domains.length === 0) {
			return '';
		}
		return domains
			.map((d) => {
				return d.libelle;
			})
			.join(', ');
	}

	prepareContactMails() {
		this.formListContactMail.forEach((contactMail) => {
			contactMail.domainNames = this.getDomainNames(contactMail.domains);
		});
	}

	onSelectSalaries(data) {
		const index = this.selectedSalaries.findIndex((item) => item.id === data.id);
		if (index !== -1) {
			this.selectedSalaries.splice(index, 1);
		} else {
			this.selectedSalaries.push(data);
		}
	}

	$onDestroy() {}
}
